// engagement.js
import './bootstrap';

import { createApp, defineAsyncComponent } from 'vue';

import QuoteFormLoader from './components/QuoteFormLoader.vue';
import ConsentBanner from './components/ConsentBanner.vue';
import { loadPrimeVue } from '@/utils/loadPrimeVue.js'

const app = createApp({});

// Provide the loader via a global property or a prop wrapper
app.provide('QuoteFormLoader', () => import('./components/EngagementQuoteForm.vue'))

app.component('quote-form-loader', QuoteFormLoader);
app.component('gallery-lazy-loader', defineAsyncComponent(() => import('./components/GalleryLazyLoader.vue')))
app.component('faq-lazy-loader', defineAsyncComponent(() => import('./components/FaqLazyLoader.vue')))
app.component('consent-banner', ConsentBanner);

await loadPrimeVue(app)

app.mount('#app');
